import React, { useEffect, lazy } from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { motion } from 'framer-motion';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
export function ContactPage() {
  useEffect(() => {
    document.title = "Contact | Walker's Martial Arts | Bloomington, Illinois";
  }, []);
  return <div className="bg-black min-h-screen" data-id="element-425">
      <Navigation data-id="element-426" />

      {/* Page Header */}
      <div className="pt-32 pb-12 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-427">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-428">
          <h1 className="text-4xl md:text-6xl font-extrabold text-white mb-6" data-id="element-429">
            Get in <span className="text-[#00D4FF]" data-id="element-430">Touch</span>
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl leading-relaxed" data-id="element-431">
            Have questions? We're here to help. Reach out to us or stop by for a
            visit.
          </p>
        </motion.div>
      </div>

      <section className="py-12 bg-[#111]" data-id="element-432">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-433">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-434">
            {/* Contact Info */}
            <div className="space-y-12" data-id="element-435">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-8" data-id="element-436">
                <div className="bg-[#1a1a1a] p-6 rounded-xl border border-gray-800" data-id="element-437">
                  <MapPin className="w-8 h-8 text-[#00D4FF] mb-4" data-id="element-438" />
                  <h3 className="text-white font-bold text-lg mb-2" data-id="element-439">
                    Visit Us
                  </h3>
                  <p className="text-gray-400 text-sm" data-id="element-440">
                    1304 E. Empire Suite 2.
                    <br data-id="element-441" />
                    Bloomington, Illinois 61701
                    <br data-id="element-442" />
                    <span className="text-xs text-gray-500" data-id="element-443">
                      (Inside the Regions Bank Complex at the intersection of
                      Empire & Towanda)
                    </span>
                  </p>
                </div>
                <div className="bg-[#1a1a1a] p-6 rounded-xl border border-gray-800" data-id="element-444">
                  <Phone className="w-8 h-8 text-[#00D4FF] mb-4" data-id="element-445" />
                  <h3 className="text-white font-bold text-lg mb-2" data-id="element-446">Call Us</h3>
                  <p className="text-gray-400" data-id="element-447">(309) 242-2440</p>
                </div>
                <div className="bg-[#1a1a1a] p-6 rounded-xl border border-gray-800" data-id="element-448">
                  <Mail className="w-8 h-8 text-[#00D4FF] mb-4" data-id="element-449" />
                  <h3 className="text-white font-bold text-lg mb-2" data-id="element-450">
                    Email Us
                  </h3>
                  <p className="text-gray-400" data-id="element-451">walkerskicks@gmail.com</p>
                </div>
                <div className="bg-[#1a1a1a] p-6 rounded-xl border border-gray-800" data-id="element-452">
                  <Clock className="w-8 h-8 text-[#00D4FF] mb-4" data-id="element-453" />
                  <h3 className="text-white font-bold text-lg mb-2" data-id="element-454">Hours</h3>
                  <p className="text-gray-400 text-sm" data-id="element-455">
                    Mon-Thu: 5am - 9pm
                    <br data-id="element-456" />
                    Fri: 5am - 7pm
                    <br data-id="element-457" />
                    Sat: 9am - 2pm
                    <br data-id="element-458" />
                    Sun: 8am - 12pm
                  </p>
                </div>
              </div>

              {/* Map */}
              <div className="w-full h-64 bg-gray-800 rounded-2xl overflow-hidden" data-id="element-459">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3915.457098203393!2d-88.97141592336078!3d40.48896885123858!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x880b6fd6c70b6475%3A0x91a7795d82d1363e!2sWalker&#39;s%20Martial%20Arts!5e1!3m2!1sen!2sus!4v1767637136317!5m2!1sen!2sus" width="100%" height="100%" style={{
                border: 0
              }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Walker's Martial Arts Location" data-id="element-460" />
              </div>
            </div>

            {/* Contact Form */}
            <div className="bg-[#1a1a1a] p-8 rounded-2xl border border-gray-800" data-id="element-461">
              <h2 className="text-2xl font-bold text-white mb-6" data-id="element-462">
                Send a Message
              </h2>
              <form className="space-y-6" data-id="element-463">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-464">
                  <div data-id="element-465">
                    <label className="block text-sm font-medium text-gray-400 mb-2" data-id="element-466">
                      First Name
                    </label>
                    <input type="text" className="w-full bg-black border border-gray-700 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-[#00D4FF] transition-colors" placeholder="John" data-id="element-467" />
                  </div>
                  <div data-id="element-468">
                    <label className="block text-sm font-medium text-gray-400 mb-2" data-id="element-469">
                      Last Name
                    </label>
                    <input type="text" className="w-full bg-black border border-gray-700 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-[#00D4FF] transition-colors" placeholder="Doe" data-id="element-470" />
                  </div>
                </div>

                <div data-id="element-471">
                  <label className="block text-sm font-medium text-gray-400 mb-2" data-id="element-472">
                    Email Address
                  </label>
                  <input type="email" className="w-full bg-black border border-gray-700 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-[#00D4FF] transition-colors" placeholder="john@example.com" data-id="element-473" />
                </div>

                <div data-id="element-474">
                  <label className="block text-sm font-medium text-gray-400 mb-2" data-id="element-475">
                    Phone Number
                  </label>
                  <input type="tel" className="w-full bg-black border border-gray-700 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-[#00D4FF] transition-colors" placeholder="(555) 123-4567" data-id="element-476" />
                </div>

                <div data-id="element-477">
                  <label className="block text-sm font-medium text-gray-400 mb-2" data-id="element-478">
                    Message
                  </label>
                  <textarea rows={4} className="w-full bg-black border border-gray-700 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-[#00D4FF] transition-colors" placeholder="How can we help you?" data-id="element-479" />
                </div>

                <button type="submit" className="w-full bg-[#00D4FF] text-black font-bold uppercase tracking-wider py-4 rounded-lg hover:bg-[#33ddff] transition-colors shadow-[0_0_20px_rgba(0,212,255,0.3)]" data-id="element-480">
                  Send Message
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      <Footer data-id="element-481" />
    </div>;
}